import React from 'react';
import * as S from './styles';

interface BarraAcoesProps {
  children: React.ReactNode;
  /** Rotulo do grupo para leitor de tela. */
  rotulo?: string;
}

/**
 * Barra de acoes sticky do padrao de UX.
 *
 * `position: sticky` em vez de `fixed`: a barra acompanha a rolagem sem sair
 * do fluxo, entao nao cobre o conteudo nem precisa de padding compensatorio.
 */
const BarraAcoes: React.FC<BarraAcoesProps> = ({
  children,
  rotulo = 'Ações da tela',
}) => (
  <S.Barra role="toolbar" aria-label={rotulo}>
    {children}
  </S.Barra>
);

export default BarraAcoes;
